import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "state";
import { Provider } from "react-redux";
import { setupListeners } from "@reduxjs/toolkit/query";
import { api } from "state/api";
import { ContextProvider } from "contexts/ContextProvider";
import { initializeApp } from "firebase/app";
import { AuthProvider } from "contexts/AuthContext";
import * as Sentry from "@sentry/react";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDukJM8gBNyhNVtEmSnwbTSRM6XErp5d_E",
  authDomain: "ce-portal-757fd.firebaseapp.com",
  projectId: "ce-portal-757fd",
  appId: "1:910368892066:web:f49da226f81e3877cb23fb",
};

// Initialize Firebase
initializeApp(firebaseConfig);

const isResizeObserverNoise = (value) => {
  const text = String(value || "");
  return (
    text.includes("ResizeObserver loop completed with undelivered notifications") ||
    text.includes("ResizeObserver loop limit exceeded")
  );
};

// Global unhandled promise rejection handler
// Prevents app freeze when axios requests fail without .catch()
window.addEventListener('unhandledrejection', (event) => {
  const reasonMessage =
    event?.reason?.message ||
    event?.reason ||
    "";

  if (isResizeObserverNoise(reasonMessage)) {
    event.preventDefault();
    return;
  }

  console.error('Unhandled promise rejection:', event.reason);
  
  // Don't prevent default for network errors - just log them
  if (event.reason?.code === 'ERR_NETWORK' || event.reason?.name === 'AxiosError') {
    console.warn('Network error caught by global handler:', event.reason.message);
    // Prevent the error from propagating and freezing the app
    event.preventDefault();
  }
});

// Suppress known benign browser ResizeObserver noise that can appear when
// MUI components reflow (especially multiline text fields) in development.
// Keep all other runtime errors visible.
window.addEventListener('error', (event) => {
  const message = String(event?.message || '');
  const stack = String(event?.error?.stack || '');

  const isResizeObserverEvent = isResizeObserverNoise(message) || isResizeObserverNoise(stack);

  if (isResizeObserverEvent) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }
}, true);

// Some development overlays forward this as console.error instead of window error.
// Filter only this known benign ResizeObserver warning.
const originalConsoleError = console.error;
console.error = (...args) => {
  if (args.some((arg) => isResizeObserverNoise(arg?.message || arg))) {
    return;
  }
  originalConsoleError(...args);
};

const store = configureStore({
  reducer: {
    global: globalReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefault) => getDefault().concat(api.middleware),
});

Sentry.init({
  dsn: "https://9f9bcd9efbc333ee08b2be5f2f6730c2@o4509232489299968.ingest.us.sentry.io/4509232493101056",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", "135.148.148.37"],
});

setupListeners(store.dispatch);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ContextProvider>
    <AuthProvider>
      <React.StrictMode>
        <Provider store={store}>
          <App />
        </Provider>
      </React.StrictMode>
    </AuthProvider>
  </ContextProvider>
);
